import React from 'react';
import PropTypes from 'prop-types';

const moveIcon = ({ width, height, color }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.9743 5.17537L12.45 2.6511C12.1475 2.34863 11.6526 2.34863 11.3501 2.6511L8.82585 5.17537C8.3364 5.66483 8.68286 6.50625 9.3758 6.50625L11.1246 6.50625L11.1246 17.5052L9.3758 17.5052C8.68836 17.4997 8.3364 18.3357 8.82585 18.8251L11.3501 21.3494C11.6526 21.6519 12.1475 21.6519 12.45 21.3494L14.9743 18.8251C15.4637 18.3357 15.1173 17.4942 14.4243 17.4942L12.6755 17.4942L12.6755 6.49525L14.4243 6.49525C15.1118 6.50075 15.4637 5.66482 14.9743 5.17537Z"
      fill={color}
    />
    <path
      d="M5.07454 15.0744L2.55027 12.5501C2.2478 12.2476 2.2478 11.7527 2.55027 11.4502L5.07454 8.92595C5.56399 8.43649 6.40542 8.78296 6.40542 9.4759L6.40542 11.2247L17.4044 11.2247L17.4044 9.4759C17.3989 8.78846 18.2348 8.43649 18.7243 8.92595L21.2486 11.4502C21.551 11.7527 21.551 12.2476 21.2486 12.5501L18.7243 15.0744C18.2348 15.5638 17.3934 15.2174 17.3934 14.5244L17.3934 12.7756L6.39442 12.7756L6.39442 14.5244C6.39992 15.2119 5.56399 15.5638 5.07454 15.0744Z"
      fill={color}
    />
  </svg>
);

moveIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
};

moveIcon.defaultProps = {
  width: 21,
  height: 21,
  color: '#3174EE',
};

export default moveIcon;
